
import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const postUserDescription = (params) => {
    return axios.post(`${backendHost}/api/admin/user/change-description`, params);
};
